import { Navigate } from 'react-router-dom';

// Composant pour protéger les routes nécessitant une authentification
function ProtectedRoute({ user, children }) {
  if (!user) {
    // Rediriger vers la page de login si non authentifié
    return <Navigate to="/admin_4Sd6c3P7/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
